module.exports = __webpack_public_path__ + "static/media/Lauren Dollerschell Headshot 1a.10366631.png";